import React from 'react';
import "./style.scss";

const MyLoadStyle = ({
  size,
  color,
  width
}) => {

  const style = {
    width: size?size:'',
    height: size?size:'',
    borderTopColor: color?color:'',
    borderWidth: width?width:''
  };
  return <>
    <div className="lds-ring">
      <div style={style}></div>
      <div style={style}></div>
      <div style={style}></div>
      <div style={style}></div>
    </div>
  </>;
}

export default MyLoadStyle;